// Libs
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import * as R from 'ramda';

// Types
import { Group } from '@components/DragAndDropContainers/types';

// Utils
import { byContent } from '../helpers';

import { constructFullName } from '@utils/constructFullName';

import { isRotaryClub } from '@domui-utils/isRotaryClub';

import { GetAllDistrictAGsByDateQuery } from './types';

export const normalizeAssignedAG = (
  agsResultData?: GetAllDistrictAGsByDateQuery,
  relatedGroupName?: string
): Group[] =>
  pipe(
    agsResultData,
    O.fromNullable,
    O.mapNullable(R.prop('AssistantGovernors')),
    O.toNullable,
    item => item || [],
    A.map(agByDate => {
      const {
        individualId = '',
        prefix,
        firstName,
        middleName,
        lastName,
        suffix,
        clubAffiliations,
      } = agByDate || {};

      const items = pipe(
        clubAffiliations,
        item => item || [],
        A.filter(club => isRotaryClub(club?.clubType)),
        A.map(club => ({
          id: club?.clubId || '',
          content: club?.clubName || '',
          data: individualId || '',
          startDate: club?.startDate,
        })),
        A.sortBy([byContent])
      );

      return {
        relatedGroupId: `groupId-${relatedGroupName || 'default'}`,
        relatedGroupName,
        groupId: relatedGroupName
          ? `${individualId}-${relatedGroupName}`
          : individualId,
        groupName: constructFullName({
          prefix,
          firstName,
          middleName,
          lastName,
          suffix,
        }),
        items,
      };
    })
  );
